//#region src/logic/identifierRoute.ts
var e = (e, t) => e === "PHONE_OTP" ? {
	step: "PHONE_OTP",
	sendPhoneOtp: !0,
	note: null
} : e === "PASSKEY" ? t ? {
	step: "PASSKEY",
	sendPhoneOtp: !1,
	note: null
} : {
	step: "PHONE_OTP",
	sendPhoneOtp: !0,
	note: "unsupported"
} : {
	step: e,
	sendPhoneOtp: !1,
	note: null
};
//#endregion
export { e as resolveIdentifierRoute };
